import createHamsClient, { HamsError } from './createHamsClient';

export { HamsError };

const client = createHamsClient();

export default client;
